// Roster entries tab (Staff Roster redesign, 2026-07-27): the flat table of
// every individual roster row. Extracted from StaffRoster.js's former inline
// table so it has its own tab. Pure display — all data/handlers are owned by
// StaffRoster.js and passed down; this component owns no fetches.
import React from "react";
import {
  Box, Chip, IconButton, LinearProgress, Paper, Table, TableBody, TableCell,
  TableHead, TableRow, TextField, MenuItem, Tooltip, Typography,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { NURSE_COLORS } from "../theme";
import { shiftLabel } from "../shiftWindow";
import { useShiftSchedule } from "../hooks";

const STATUS_OPTIONS = [
  { value: "on_duty", label: "On Duty" },
  { value: "overtime", label: "Overtime" },
  { value: "leave", label: "Leave" },
  { value: "na", label: "N/A" },
];

export default function RosterEntriesTab({
  rows, hoursByNurse, wardNameByCode, nurseNameById = {}, savingId, loading,
  onStatusChange, onRemove,
}) {
  const { schedule } = useShiftSchedule();
  return (
    <Box>
      {loading && <LinearProgress sx={{ mb: 2 }} />}
      <Paper sx={{ borderRadius: 2, border: `1px solid ${NURSE_COLORS.border}`, overflowX: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: NURSE_COLORS.pageBg }}>
              <TableCell>Nurse</TableCell><TableCell>Hours (wk)</TableCell><TableCell>Ward</TableCell><TableCell>Shift</TableCell><TableCell>Date</TableCell><TableCell>Status</TableCell><TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.nurse_name || nurseNameById[row.nurse_id] || row.nurse_id}</TableCell>
                <TableCell>
                  {hoursByNurse[row.nurse_id] ? (
                    <Tooltip title={`${hoursByNurse[row.nurse_id].overtime_rows || 0} overtime shift(s) this week`}>
                      <Chip
                        size="small"
                        label={`${hoursByNurse[row.nurse_id].hours} h`}
                        color={(hoursByNurse[row.nurse_id].overtime_rows || 0) >= 2 ? "warning" : "default"}
                        variant="outlined"
                      />
                    </Tooltip>
                  ) : "—"}
                </TableCell>
                <TableCell>{wardNameByCode[row.ward_code] || row.ward_code}</TableCell>
                <TableCell>{shiftLabel(row.shift, schedule)}</TableCell>
                <TableCell>{row.roster_date}</TableCell>
                <TableCell>
                  <TextField
                    select size="small" value={row.status} disabled={savingId === row.id}
                    onChange={(e) => onStatusChange(row, e.target.value)}
                    sx={{ minWidth: 130 }}
                  >
                    {STATUS_OPTIONS.map((s) => (<MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>))}
                  </TextField>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Remove roster row">
                    <span>
                      <IconButton size="small" color="error" disabled={savingId === row.id} onClick={() => onRemove(row)}>
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                    </span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {!loading && rows.length === 0 && (
              <TableRow><TableCell colSpan={8} align="center"><Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>No roster rows yet.</Typography></TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
